import { useQuery } from "@tanstack/react-query";
import httpClient from "helpers/hybridHttpClient";
import type { GetServerSidePropsContext } from "next";

import type { ReleaseAccess } from "types/release";

export const fetchReleaseAccess = async (
  releaseId: number,
  ctx?: GetServerSidePropsContext,
) => {
  const { data } = await httpClient(ctx).get<ReleaseAccess>(
    `/api/courses-user/releases/${releaseId}/access/`,
  );

  return data;
};

export const useReleaseAccess = (
  releaseId: number | null,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["releaseAccess", releaseId],
    queryFn: () => (releaseId ? fetchReleaseAccess(releaseId) : null),
    enabled,
  });
};
